import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { LanguageService } from 'src/app/services/language.service';
import { TranslationService } from 'src/app/services/translation.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  translationData = [];
  isFooterAvailable : boolean = false;
  featureFlags: any= this.translationService.featureFlags;
  isExplorePage: boolean = false;
  currentLanguage = 'de-DE';
  language: string = 'de-DE';
  isLanguageSelector: boolean = false;
  languageToDisplay: string = 'Deutsch';

  @Output() scrollToTop = new EventEmitter();
  showLangPicker: boolean = false;

  constructor(private readonly translationService: TranslationService,
    private readonly router: Router, 
    private readonly languageService: LanguageService,
  ) {
    let isExploreScreen = false;
    this.router?.events?.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        isExploreScreen = event.url.includes('explore');
        this.isExplorePage = this.featureFlags?.general.enableExplore && isExploreScreen;
      }
    });
    this.featureFlags = this.translationService.featureFlags;
    this.isFooterAvailable = this.featureFlags?.general.isfooterAvailable;
    this.language = this.languageService.getLanguage();
    this.getUserSelectedLanguage(this.language);
  }

  public getUserLanguage(): void {
    let data = localStorage.getItem('language') ?? 'de-DE';
    if (data === 'en-GB') {
      this.currentLanguage = 'Deutsch';
    } else {
    const supportedLocales: any = {
          'de-DE': 'Deutsch',
          'ko-KR': 'Korean',
          'fr-FR': 'French',
          'es-ES': 'Spanish',
        }
        data = supportedLocales[data] ? data : 'de-DE';
        this.currentLanguage = supportedLocales[data];
      }
  }

  public ngOnInit() {
    this.translationService.getTranslationDataAsObservable().subscribe(
      (translationData: any) => {
        this.translationData = translationData;
        this.language = this.languageService.getLanguage();
        this.getUserSelectedLanguage(this.language);
      }
    )

    if(this.featureFlags?.general.enableLanguageSelector){
      this.isLanguageSelector = true;
    }

  }

  public openPrivacyPage(): void {
    this.scrollTop();
    const selectedLang = localStorage.getItem('language') ?? 'en-GB';
    this.router.navigate(['/' + selectedLang + '/privacy']);
  }

  public openProviderPage(): void {
    this.scrollTop();
    const selectedLang = localStorage.getItem('language') ?? 'en-GB';
    this.router.navigate(['/' + selectedLang + '/provider']);
  }

  public openLegalPage(): void {
    this.scrollTop();
    const selectedLang = localStorage.getItem('language') ?? 'en-GB';
    this.router.navigate(['/' + selectedLang + '/legal-notice']);
  }

  public switchLanguage(language:string) {
    const supportedLocales: any = {
      'English': 'en-GB',
      'Deutsch': 'de-DE',
      'Korean': 'ko-KR',
      'French': 'fr-FR',
      'Spanish': 'es-ES',
      'Czech': 'cs-CZ'
    }
    const selectedLang = (url: string) => supportedLocales[url] ? supportedLocales[url] : 'de-DE';
    const fullURL = window.location.href.split('/');
    const langIndex = fullURL.findIndex(part => this.languageService.checkIsValideLanguage(part));
    fullURL[langIndex] = selectedLang(language);
    localStorage.setItem('language', selectedLang(language));
    window.location.href = fullURL.join('/');
    this.currentLanguage = language;
  }

  public getUserSelectedLanguage(langCode: string) {
    let languageFromUrl = langCode;
    const supportedLocales: any[] = this.translationService.supportedLanguagesForDisplay;
    const fullURL = window.location.href.split('/');
    const langIndex = fullURL.findIndex(part => this.languageService.checkIsValideLanguage(part));
    if (langIndex !== -1) {
      languageFromUrl = fullURL[langIndex];
    }
    if (this.featureFlags?.general.enableLanguageSelector && supportedLocales.length) {
      this.languageToDisplay = supportedLocales.find((lang: { localeCode: string; }) => lang.localeCode === languageFromUrl)?.localeDescription ?? 'English';
    }

  }

  public scrollTop(): void {
    window.scroll({
      top:0,
      left:0,
      behavior:'smooth'
    })
  }
  
  openLanguagePicker(){
    this.languageService.showLanguageSelectionPage(true);
  }

}
